import { apiBaseQuery } from "@cognitranlimited/itis-web";
import { createApi } from "@reduxjs/toolkit/query/react";
export var vehicleSpecificationApi = createApi({
    reducerPath: "vehicleSpecificationApi",
    baseQuery: apiBaseQuery(),
    tagTypes: ["VehicleSpecification"],
    endpoints: function (builder) { return ({
        getVehicleSpecificationMatrix: builder.query({
            query: function (_a) {
                var vehicleCode = _a.vehicleCode, documentSourceId = _a.documentSourceId;
                return "/sis-codes/".concat(vehicleCode, "/").concat(documentSourceId);
            },
            providesTags: function (_result, _error, _a) {
                var vehicleCode = _a.vehicleCode, documentSourceId = _a.documentSourceId;
                return [
                    {
                        type: "VehicleSpecification",
                        id: "".concat(vehicleCode, "_").concat(documentSourceId),
                    },
                ];
            },
        }),
    }); },
});
export var useGetVehicleSpecificationMatrixQuery = vehicleSpecificationApi.useGetVehicleSpecificationMatrixQuery;
